import React, { forwardRef, useMemo } from 'react'
import { FieldTypes, urlRegexValidator } from 'utils/formUtils';
import StackhawkMappingForm from './StackhawkMappingForm';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';

function StackhawkCredentialsForm(props, ref) {
    const fields = useMemo(() => (
        [{
            name: "apiEndpoint",
            label: "API Endpoint",
            required: true,
            rules:[urlRegexValidator],
        }, {
            name: "token",
            label: "Token",
            required: true,
            type: FieldTypes.PASSWORD,
        }, {
            name: "orgId",
            label: "Organization Id",
            required: true,
            help: "The Organization ID can be found under Settings → Organization Details in your StackHawk account."
        }]
    ),[])

    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            MappingForm={StackhawkMappingForm}
        />
    )
}

export default forwardRef(StackhawkCredentialsForm);